import Vue from 'vue'

import store from 'store'
import listModeComponentTemplate from './listModeComponentTemplate'

Vue.config.devtools = false
Vue.config.productionTip = false

const { postData } = require('js/api/getdata').default


export default {
  listMode(info, vm, mountEl) {
    if (document.getElementById('new-file-box') !== null) {
      return
    }
    let list; let
      folderNode
    if (!mountEl) {
      store.commit('hasRename', true)
      store.commit('setCreateInput', true)
      // let pNode = document.createElement("div");  //节点多加一层，添加has-show-right类，解决大图模式空列表新建样式问题
      // pNode.className = localStorage.getItem('conRightSwitch') == 'open' ? 'has-show-right' : '';
      const node = document.createElement('div')
      // pNode.appendChild(node)
      node.id = 'new-file-box'
      node.className = 'filelist-item'
      node.style.clear = 'left'
      node.innerHTML = '<div id="new-file" class="filelist-item-inner"></div>'

      list = document.getElementById('scroll-content')
      folderNode = document.querySelectorAll('.isfolder-true')

      if (localStorage.getItem('Mode') === 'icon' && info.fileType && folderNode[folderNode.length - 1]) {
        const parent = folderNode[folderNode.length - 1].parentNode

        if (parent.lastChild == folderNode[folderNode.length - 1]) {
          parent.appendChild(node)
        } else {
          // parent.insertBefore(node, folderNode[folderNode.length - 1].nextSibling);
          list.insertBefore(node, list.childNodes[0]) // 新建放在第一个
        }
      } else if (document.getElementsByClassName('filelist-item').length > 0) {
        list.insertBefore(node, list.childNodes[0])
      } else {
        const listWrapper = document.getElementById('list-wrapper')
        listWrapper.insertBefore(node, listWrapper.childNodes[3])
      }
    }

    const DOM = Vue.extend({
      render: (createElement) => createElement(listModeComponentTemplate, {
        props: {
          fileInfo: info,
          mountEl,
          vm,
        },
      }),
    })
    const newFileDom = new DOM({
      el: document.createElement('div'),
    })
    if (mountEl) {
      mountEl.appendChild(newFileDom.$el)
    } else {
      document.getElementById('new-file').appendChild(newFileDom.$el)
      if (list) list.scrollTop = 0
      const virtualList = document.getElementById('virtual-scroll-wrapper')
      if (virtualList) virtualList.scrollTop = 0
    }
  },
}
